import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import moment from 'moment';
import { ComponentBase } from '../component.base';


@Component({
    selector: 't4-timePicker',
    templateUrl: './timePicker.html',
    styleUrls: ['./timePicker.css'],
    exportAs: "T4TimePicker",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimePickerComponent extends ComponentBase implements AfterViewInit {
    @Input() minTime: moment.Moment = moment().startOf('day');
    @Input() maxTime: moment.Moment = moment().startOf('day').add(23, 'hours').add(59, 'minutes');
    @Input() steps: string = "hour";
    @Input() disabled: boolean = false;
    @Input() overrideTimeLimits: boolean = false;

  @ViewChild("txtTime", { static: false }) private txtTime: NgModel;
  @ViewChild("mnuOptions", { static: false }) public mnuOptions: ElementRef;

    private _isDirty: boolean = false;
    public get isDirty(): boolean {
        return this._isDirty;
    }

    private _selectedTime: moment.Moment;
    public get selectedTime(): moment.Moment {
        return this._selectedTime;
    }
    @Input()
    public set selectedTime(val: moment.Moment) {
        var m = 60;
        switch (this.steps) {
            case 'halfhour':
                m = 30;
                break;

            case 'quarter':
                m = 15;
                break;

            default:
                m = 60;
                break;
        }
        this._selectedTime = val ? this.round(val, m, "Minutes") : null;
    }
    @Output() selectedTimeChange = new EventEmitter<moment.Moment>();

    public get timeValue(): string {
        return this._selectedTime ? this._selectedTime.format("HH:mm") : '';
    }
    @Input()
    public set timeValue(val: string) {
        var dt = this.selectedTime;
        if (val.length == 5) {
            dt = moment(this.selectedTime.format("YYYY-MM-DD") + " " + val);
        } else if (val.length == 4 && val.indexOf(":") < 0) {
            dt = moment(this.selectedTime.format("YYYY-MM-DD") + " " + val.substring(0, 2) + ":" + val.substring(2, 4));
        } else if (val.length == 3 && val.indexOf(":") < 0) {
            dt = moment(this.selectedTime.format("YYYY-MM-DD") + " 0" + val.substring(0, 1) + ":" + val.substring(1, 3));
        }

        if (dt != this.selectedTime && dt.isValid()) {
            var m = 60;
            switch (this.steps) {
                case 'halfhour':
                    m = 30;
                    break;

                case 'quarter':
                    m = 15;
                    break;

                default:
                    m = 60;
                    break;
            }
            dt = this.round(dt, m, "Minutes");

            var opt = this.options.find(x => x.time.format("HH:mm") == dt.format("HH:mm"));
            if (opt) this.selectTime(opt, true);
            
            this.txtTime.control.setValue(this.selectedTime.format("HH:mm"));
        } else {
            this.txtTime.control.setValue(this.selectedTime.format("HH:mm"));
        }
    }

    public options: TimeOption[] = [];
    public selectedOption: TimeOption;

    public selectorOpen: boolean = false;

    constructor(private zone: NgZone) {
        super();
    }

    ngOnChanges(changes: SimpleChanges) {

        // Update open hours
        if (
            (changes.minTime && changes.minTime.previousValue != changes.minTime.currentValue) ||
            (changes.maxTime && changes.maxTime.previousValue != changes.maxTime.currentValue)
        ) {
            if (this.maxTime && this.minTime) {
                this.Render();
            }
        }

        // Handle selected time
        if (changes.selectedTime && changes.selectedTime.previousValue != changes.selectedTime.currentValue) {
            for (var x of this.options) {
                if (x.time.format("HH:mm") == this.selectedTime.format("HH:mm")) {
                    if (!x.isSelected) this.selectTime(x, false);
                    break;
                }
            }
        }
    }


  ngAfterViewInit() {
    this.Render();
  }

    private Render() {
        if (this._selectedTime) {
            this.minTime.year(this._selectedTime.year());
            this.minTime.month(this._selectedTime.month());
            this.minTime.date(this._selectedTime.date());

            this.maxTime.year(this._selectedTime.year());
            this.maxTime.month(this._selectedTime.month());
            this.maxTime.date(this._selectedTime.date());
        }

        this.options = [];
        this.selectedOption = null;

        var t = this.minTime.clone().startOf('day');
        var max = this.maxTime.clone().endOf('day');

        if (this.maxTime.isSame(this.maxTime.clone().startOf('day'))) this.maxTime = this.maxTime.clone().hour(23).minute(59);

        while (t <= max) {
            var opt = { time: t.clone(), text: t.format("HH:mm"), isValid: t >= this.minTime && t < this.maxTime, isSelected: false };
            if (this.selectedTime && (t.format("HH:mm") == this.selectedTime.format("HH:mm") || (!this.selectedTime && opt.isValid))) this.selectTime(opt, false);
            this.options.push(opt);

            switch (this.steps) {
                case 'halfhour':
                    t = t.add(30, 'minutes');
                    break;

                case 'quarter':
                    t = t.add(15, 'minutes');
                    break;

                default:
                    t = t.add(1, 'hour');
                    break;
            }
        }
    }

    public openSelector(event) {
        if (this.disabled) return;


        this.selectorOpen = true;
        this.UI.float(this.mnuOptions.nativeElement, event.clientX - 10, event.clientY - 10);

        if (this.selectedOption) {
            let el = document.getElementById("time" + this.selectedOption.text);
            this.mnuOptions.nativeElement.scrollTop = el.offsetTop - 50;
        }
    }

    public selectTime(t: TimeOption, isUserSelection: boolean = true) {
        if (!t.isValid && !this.overrideTimeLimits) return;

        if (isUserSelection && this.selectedTime != t.time) this._isDirty = true;

        this.selectedTime = t.time;
        this.selectedTimeChange.emit(this.selectedTime);
        t.isSelected = true;

        if (this.selectedOption) this.selectedOption.isSelected = false;
        this.selectedOption = t;
        this.selectorOpen = false;      
        const timeSelector = this.mnuOptions.nativeElement as HTMLElement;
          if (timeSelector) {
            timeSelector.style.display = 'none';
          }  
    }

    private round(date: moment.Moment, precision: number, key: string): moment.Moment {
        var direction = 'round';

        var keys = ['Hours', 'Minutes', 'Seconds', 'Milliseconds'];
        var maxValues = [24, 60, 60, 1000];

        // Capitalize first letter
        key = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();

        // make sure key is plural
        if (key.indexOf('s', key.length - 1) === -1) {
            key += 's';
        }
        var value = 0;
        var rounded = false;
        var subRatio = 1;
        var maxValue;
        for (var i in keys) {
            var k = keys[i];
            if (k === key) {
                value = date.toDate()['get' + key]();
                maxValue = maxValues[i];
                rounded = true;
            } else if (rounded) {
                subRatio *= maxValues[i];
                value += date.toDate()['get' + k]() / subRatio;
                date.toDate()['set' + k](0);
            }
        };

        value = Math[direction](value / precision) * precision;
        value = Math.min(value, maxValue);
        return moment(date.toDate()['set' + key](value));
    }

    public markAsPristine() {
        this._isDirty = false;
  }

  public handleMouseLeave(event: MouseEvent) {
    const timeSelector = this.mnuOptions.nativeElement as HTMLElement;
    if (timeSelector) {
      timeSelector.style.display = 'none';
    } 
  }
}

class TimeOption {
    public time: moment.Moment;
    public text: string = "";
    public isValid: boolean = false;
    public isSelected: boolean = false;
}
